import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1255d85b"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Fragmented Memories Toolkit ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("  — ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("New Character");

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getTransitions, getUtils, getStoreUtils } from '@fm-tools/core/composables';
import { CharacterSelect, AccountNav } from '@fm-tools/nav';
import { CHECK_VERSION } from '@fm-tools/core/store/actions';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const theme = ref('dark' || 'FMDarkTheme');
    const drawer = ref(false);
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const {
      nav
    } = getUtils();
    const {
      characters
    } = getStoreUtils();
    const currentTitle = computed(() => nav.value.find(u => u.link === route.path)?.title || nav.value.find(u => u.link === route.path)?.name || '');
    const {
      transitionName,
      transitionMode,
      transitionEnterActiveClass,
      beforeEach
    } = getTransitions();
    router.beforeEach(beforeEach);
    onMounted(() => store.dispatch(CHECK_VERSION));
    return (_ctx, _cache) => {
                                                            

                                                          

      const _component_v_list_item_icon = _resolveComponent("v-list-item-icon");

                                                                                  

      const _component_v_list_item_content = _resolveComponent("v-list-item-content");

                                                                      

                                                            

                                                          

                                                                                      

                                                                                        

                                                                              

                                                                

                                                                  

      const _component_router_view = _resolveComponent("router-view");

                                                            

                                                          

      return _openBlock(), _createBlock(_component_v_app, {
        theme: theme.value
      }, {
        default: _withCtx(() => [_createVNode(_component_v_btn, {
          elevation: "2",
          fab: "",
          rounded: "",
          text: "",
          small: "",
          class: "nav-button",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => drawer.value = !drawer.value, ["stop"]))
        }, {
          default: _withCtx(() => [_createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [!drawer.value ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              icon: "mdi-menu"
            })) : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              icon: "mdi-close"
            }))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_navigation_drawer, {
          app: "",
          clipped: "",
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => drawer.value = $event)
        }, {
          append: _withCtx(() => [_createVNode(_component_v_row, {
            justify: "center",
            align: "center",
            class: "pb-5 px-auto",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [_createElementVNode("small", null, [_createElementVNode("small", null, [_createElementVNode("small", null, "FM Tools Version " + _toDisplayString(_unref(store).getters.appVersion), 1)])])]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_v_list, {
            class: "pt-16"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nav), (i, index) => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: index,
                link: "",
                disabled: !i.link,
                to: i.link
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    icon: i.icon
                  }, null, 8, ["icon"])]),
                  _: 2
                }, 1024), _createVNode(_component_v_list_item_content, null, {
                  default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                    title: i.title
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(i.label || i.name), 1)]),
                    _: 2
                  }, 1032, ["title"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["disabled", "to"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_v_app_bar, {
          app: "",
          "clipped-left": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_v_app_bar_title, {
            class: _normalizeClass(["nav-title", {
              active: drawer.value
            }])
          }, {
            default: _withCtx(() => [_hoisted_1, _unref(currentTitle) ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_hoisted_2, _createVNode(_component_v_slide_x_transition, null, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(currentTitle)), 1)]),
              _: 1
            })], 64)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_v_spacer), _unref(store).getters.isAuthenticated ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            text: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_v_icon, {
              left: "",
              icon: "mdi-account-plus"
            }), _hoisted_3]),
            _: 1
          })) : _createCommentVNode("", true), _unref(store).getters.isAuthenticated && _unref(characters) !== undefined && _unref(characters).length > 0 ? (_openBlock(), _createBlock(_unref(CharacterSelect), {
            key: 1
          })) : _createCommentVNode("", true), _createVNode(_unref(AccountNav))]),
          _: 1
        }), _createVNode(_component_v_main, {
          class: "fm-main"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_view, null, {
            default: _withCtx(({
              Component
            }) => [_createVNode(_Transition, {
              name: _unref(transitionName),
              mode: _unref(transitionMode),
              "enter-active-class": _unref(transitionEnterActiveClass)
            }, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
              _: 2
            }, 1032, ["name", "mode", "enter-active-class"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["theme"]);
    };
  }

});

/* Vuetify */
import { VApp as _component_v_app } from "vuetify/lib/components/VApp/index.mjs"
import { VAppBarTitle as _component_v_app_bar_title, VAppBar as _component_v_app_bar } from "vuetify/lib/components/VAppBar/index.mjs"
import { VBtn as _component_v_btn } from "vuetify/lib/components/VBtn/index.mjs"
import { VRow as _component_v_row, VSpacer as _component_v_spacer } from "vuetify/lib/components/VGrid/index.mjs"
import { VIcon as _component_v_icon } from "vuetify/lib/components/VIcon/index.mjs"
import { VListItemTitle as _component_v_list_item_title, VListItem as _component_v_list_item, VList as _component_v_list } from "vuetify/lib/components/VList/index.mjs"
import { VMain as _component_v_main } from "vuetify/lib/components/VMain/index.mjs"
import { VNavigationDrawer as _component_v_navigation_drawer } from "vuetify/lib/components/VNavigationDrawer/index.mjs"
import { VSlideXTransition as _component_v_slide_x_transition } from "vuetify/lib/components/transitions/index.mjs"

